const gatetime = [
  {
    path: '/attendance/gatetime/current',
    component: () => import('@/page/attendance/gatetime/Current.vue'),
    meta: {
      name: '출퇴근 현황',
      isActive: false,
      isBread: false,
    },
  },
  {
    path: '/attendance/gatetime/applied',
    component: () => import('@/page/attendance/gatetime/Apply.vue'),
    meta: {
      name: '신청함',
      isActive: false,
      isBread: false,
    },
  },
];

export default gatetime;
